import { PortalType } from "@studyportals/domain-client";
import { EducationLevelFilterValue } from "@studyportals/search-api-interface";

const getEducationLevel = (): EducationLevelFilterValue[] => {
	switch (window.PortalType) {
	case PortalType.BACHELOR:
		return [EducationLevelFilterValue.BACHELOR];
	case PortalType.MASTER:
		return [EducationLevelFilterValue.MASTER];
	case PortalType.PHD:
		return [EducationLevelFilterValue.PHD];
	case PortalType.SHORT:
		return [EducationLevelFilterValue.SHORT_COURSE];
	case PortalType.DISTANCE_LEARNING:
		return [EducationLevelFilterValue.DISTANCE_LEARNING];
	default:
		return [EducationLevelFilterValue.MASTER];
	}
}

export default getEducationLevel;